export const sameDateLastYear = (date) => {
  const splitDate = date.split('-')
  const month = splitDate[1]
  const time = splitDate[2]
  const year = parseInt(splitDate[0]) - 1

  return `${year}-${month}-${time}`
}
